module.exports = __webpack_public_path__ + "static/fipclemonbrave2-7ba3e57939810a9dd86f821eb9259b67.jpeg";